const Stop = () => {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_829_3843)">
        <rect
          x="1"
          y="1"
          width="64"
          height="64"
          rx="32"
          fill="black"
          fillOpacity="0.5"
        />
        <rect
          x="1"
          y="1"
          width="64"
          height="64"
          rx="32"
          stroke="white"
          strokeOpacity="0.2"
          strokeWidth="1.5"
        />
        <path
          d="M25 24V42"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M41 24V42"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_829_3843"
          x="-3.75"
          y="-3.75"
          width="73.5"
          height="73.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_829_3843"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_829_3843"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default Stop
